import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "bodyText"

export const presets = {
  size: {
    sm: "text-sm",
    md: "text-md",
    lg: "text-lg",
    xl: "text-xl",
  },
}

export interface Props extends Component {
  size?: keyof typeof presets.size
  as?: "p" | "div" | "span"
}

export function BodyText({
  as: Elem = "div",
  size = "md",
  children,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  const resolvedSize = presets.size[size]

  return (
    <Elem
      className={cx("leading-relaxed", resolvedSize, resolvedSize, className)}
      data-test={testId}
    >
      {children}
    </Elem>
  )
}
